import { render, staticRenderFns } from "./OperatorMissionPriorityDatatableNoteNumberRenderer.vue?vue&type=template&id=2e64e6ec&"
import script from "./OperatorMissionPriorityDatatableNoteNumberRenderer.vue?vue&type=script&lang=ts&"
export * from "./OperatorMissionPriorityDatatableNoteNumberRenderer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports